import type { ReactElement, ReactNode } from 'react'
import { ChevronToggle } from 'app/components/ChevronToggle'
import { Button } from 'app/components/ui/button'

export function NavSectionHeader({
  label,
  action,
  collapsed,
  onToggle,
}: {
  label: string
  action?: ReactNode
  collapsed?: boolean
  onToggle?: () => void
}): ReactElement {
  const heading = <h2 className="text-label-xs uppercase tracking-wide text-subtle">{label}</h2>

  return (
    <div className="flex h-10 items-center justify-between pl-2 pr-1 pt-5">
      {onToggle ? (
        <Button variant="ghost" size="inline" aria-expanded={!collapsed} onClick={onToggle} className="group">
          {heading}
          <ChevronToggle
            open={!collapsed}
            className="ml-1 p-0 opacity-0 group-hover:opacity-100 group-aria-[expanded=false]:opacity-100"
            chevronClassName="h-3.5 w-3.5 text-subtle"
          />
        </Button>
      ) : (
        heading
      )}
      {action}
    </div>
  )
}
